'use client';
import React, { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import dynamic from 'next/dynamic';
import style from './header.module.scss';
import classNames from 'classnames';
import { useAppSelector } from '@/src/v2/hooks/useAppSelector/UseAppSelector';
import {
  useIsSidebarOpenSelector,
  useUserSelector,
} from '@/src/v2/store/selectors';
import { IUserResponseV2 } from '@/src/v2/service/v2/graphql/generated/gql-api.generated';
import { getQueryClient } from '@/src/v2/service/graphql/api';
import {
  GetCarouselEventsV3,
  GetLiveEventsV3,
  GetUpcomingEventsV3,
  GetPastEvents,
  GetCategoryWithEvents,
  GetCategoryWithScheduleEvents,
  GetCategoryWithEventsV2,
  GetCategoriesV2,
  GetTrendingCategory,
} from '@/src/v2/service/v2/graphql/apiv2';
//import DropdownList from '@/src/v2/components/DropdownList/DropdownList';
import { useAppDispatch } from '../../hooks/useAppDispatch/UseAppDispatch';
import { setUser } from '../../store/slices/user/UserSlice';
import { setChannel } from '@/src/v2/store/slices/user/UserSlice';
import { BiArrowToLeft } from 'react-icons/bi';
import { setIsSidebarOpen } from '../../store/slices/presentation/PresentationSlice';
import { setMobileProfileMenuStatus } from '../../store/slices/mobileMenu/MobileMenuSlice';
import { FaChevronRight } from 'react-icons/fa';
import { queryConfig } from '@/src/utils/cache/queryConfig';
const NewSidebarDynamic = dynamic(() => import('../sidebarV2/newSidebar'), {
  ssr: false,
});
const HeaderSearchDynamic = dynamic(() => import('./HeaderSearch'), {
  ssr: false,
});
const LogoIconDynamic = dynamic(() => import('../../assets/icons/LogoIcon'), {
  ssr: false,
});
const Icon = dynamic(() => import('@/src/v2/components/Icon'), { ssr: false });
const AvatarMenu = dynamic(
  () => import('@/src/v2/layout/Header/AuthorizedMenu/AvatarMenu'),
  { ssr: false }
);
const UnauthorizedMenu = dynamic(
  () => import('@/src/v2/layout/Header/UnauthorizedMenu/UnauthorizedMenu'),
  { ssr: false }
);

const Header: FC<{ user: IUserResponseV2 }> = ({ user }) => {
  // const queryClient = getQueryClient();
  const pageType = useAppSelector((state) => state.presentation.menuBoard);
  const router = useRouter();
  const isMenuOpen = useAppSelector(useIsSidebarOpenSelector);
  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState<boolean>(false);
  const reduxUser = useAppSelector(useUserSelector);
  const [LocalUser, setLocalUser] = useState<IUserResponseV2>(null);
  const dispatch = useAppDispatch();
  // queryClient.prefetchQuery(
  //   [`GetCarouselEventsV3`],
  //   () => GetCarouselEventsV3(),
  //   {
  //     ...queryConfig,
  //   }
  // );
  // queryClient.prefetchQuery(
  //   [`GetLiveEventsV3`],
  //   () => GetLiveEventsV3({ page: 0, limit: 20 }),
  //   {
  //     ...queryConfig,
  //   }
  // );
  // queryClient.prefetchQuery(
  //   [`GetUpcomingEventsV3`],
  //   () => GetUpcomingEventsV3({ page: 0, limit: 20 }),
  //   {
  //     ...queryConfig,
  //   }
  // );
  // queryClient.prefetchQuery(
  //   [`GetPastEvents`],
  //   () => GetPastEvents({ page: 0, limit: 20 }),
  //   {
  //     ...queryConfig,
  //   }
  // );
  // queryClient.prefetchQuery(
  //   [`GetCategoryWithEvents`],
  //   () => GetCategoryWithEvents({ page: 0, limit: 10 }),
  //   {
  //     ...queryConfig,
  //   }
  // );
  // queryClient.prefetchQuery(
  //   [`GetCategoryWithScheduleEvents`],
  //   () => GetCategoryWithScheduleEvents({ page: 0, limit: 10 }),
  //   {
  //     ...queryConfig,
  //   }
  // );
  // queryClient.prefetchQuery(
  //   [`GetCategoryWithEventsV2`],
  //   () => GetCategoryWithEventsV2({ page: 0, limit: 10 }),
  //   {
  //     ...queryConfig,
  //   }
  // );
  // queryClient.prefetchQuery([`GetCategoriesV2`], () => GetCategoriesV2(), {
  //   ...queryConfig,
  // });
  // queryClient.prefetchQuery(
  //   [`GetTrendingCategory`],
  //   () => GetTrendingCategory({ page: 0, limit: 20 }),
  //   {
  //     ...queryConfig,
  //   }
  // );
  useEffect(() => {
    setLocalUser(reduxUser);
    return () => {
      setLocalUser(null);
    };
  }, [reduxUser]);

  useEffect(() => {
    dispatch(setUser(user));
    dispatch(setChannel(user?.channel));
  }, [user]);

  const actionHandler = async (action: string) => {
    const [actionType, actionValue] = action.split(':');
    switch (actionType) {
      case 'route':
        await router.push(actionValue);
        break;
      case 'contactUs':
        window.open('https://discord.gg/baYDJCQgqy', '_blank');
        break;
      default:
        break;
    }
    setIsBurgerMenuOpen(false);
  };
  const dropdownItems = [
    {
      label: 'Contact Us',
      value: `route:/contact-us`,
      icon: 'ContactUssm',
    },
    {
      label: 'Terms Of Service',
      value: `route:/terms-of-service`,
      icon: 'TermsOfUsesm',
    },
    {
      label: 'Privacy Policy',
      value: `route:/privacy-policy`,
      icon: 'TermsOfUsesm',
    },
    {
      label: 'Cookie Policy',
      value: `route:/cookie-policy`,
      icon: 'CookiePrference',
    },
    {
      label: 'Terms Of Sale',
      value: `route:/terms-of-sale`,
      icon: 'TermsOfUsesm',
    },
    {
      label: 'Refund Policy',
      value: `route:/refund-policy`,
      icon: 'TermsOfUsesm',
    },
    {
      label: 'Community Guidelines',
      value: `route:/community-guideline`,
      icon: 'legal',
    },
    {
      label: 'DMCA Policy',
      value: `route:/dmca-policy`,
      icon: 'TermsOfUsesm',
    },
  ];
  return (
    <>
      <header
        className={classNames(style['header'], {
          [style['header--with-short']]: !isMenuOpen,
        })}
      >
        <BiArrowToLeft
          onClick={() => {
            dispatch(setIsSidebarOpen(isMenuOpen == true ? false : true));
          }}
          size={18}
          className={classNames(
            style[`header--${!isMenuOpen ? 'rotated' : 'non-rotated'}`]
          )}
        />

        <HeaderSearchDynamic isMenuOpen={isMenuOpen} />

        <NewSidebarDynamic pageType={pageType} />

        <div className={classNames(style['header__search--sm'])}>
          <>
            <>
              {pageType !== 'event' && (
                <div
                  className={classNames(style['logo'])}
                  onClick={() => {
                    dispatch(setMobileProfileMenuStatus(false));
                    router.push('/');
                  }}
                >
                  <LogoIconDynamic isBeta={true} />
                </div>
              )}
              {pageType === 'event' && (
                <Icon
                  icon="backTo"
                  width={23}
                  height={23}
                  onClick={() => {
                    dispatch(setMobileProfileMenuStatus(false));
                    router.back();
                  }}
                />
              )}
            </>
            {pageType !== 'event' && (
              <div
                className={`${style['burger-icon']} ${
                  isBurgerMenuOpen ? style['burger-icon__open'] : ''
                }`}
              >
                <Icon
                  onClick={() => {
                    dispatch(setMobileProfileMenuStatus(false));
                    setIsBurgerMenuOpen((val) => !val);
                  }}
                  icon={`${isBurgerMenuOpen ? 'menuClose' : `burgerMenu`}`}
                />
              </div>
            )}
            {isBurgerMenuOpen && (
              <div className={`${style['burger']}`}>
                <div className={`${style['burger--title']}`}>Resources</div>
                <div className={`${style['burger--wrap']}`}>
                  {dropdownItems.map((item) => (
                    <div
                      className={`${style['burger--wrap--link']}`}
                      key={item.label}
                      onClick={() => actionHandler(item.value)}
                    >
                      <div>
                        <Icon icon={item.icon} width={20} height={20} />
                        <span> {item.label}</span>
                      </div>{' '}
                      <FaChevronRight />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        </div>
        <div className={`${style['header__actions']}`}>
          {!LocalUser && <UnauthorizedMenu />}
          {LocalUser && <AvatarMenu user={LocalUser} />}
        </div>
      </header>
    </>
  );
};

export default Header;
